var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.splitLicenses),function(li,index){
var _obj;
return [_c('span',{key:index,staticClass:"is-block margin-vertical-small"},[_c('i',{class:( _obj = {
          icon: true
        }, _obj['has-text-black'] = true, _obj['has-background-white'] = true, _obj['is-size-4'] = true, _obj['margin-right-small'] = true, _obj[("cc-" + (_vm.getLicenseIcon(li)))] = true, _obj ),attrs:{"alt":("" + (li.toUpperCase()))}}),_vm._v("\n        "+_vm._s(_vm.getLicenseDescription(li))+"\n    ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }